module.exports = __webpack_public_path__ + "img/gray-stop-icon.bdea7f1a.svg";